'use client';

import Link from '@eliadmin/core/src/components/link';
import { useEffect, useState } from 'react';

import type {
  GeneralLayout,
  Menu,
} from '@eliadmin/core/src/api/general/types/general-layout-types';

import { cn } from '@eliadmin/core/src/utils/style-utils';
import { Navigation } from './navigation';
import { Logo } from '../ui/logo';
import { Button } from '@eliadmin/core/src/components/ui/button';
import { ButtonIcon } from '../ui/button-icon';
import MobileSidebar from '@eliadmin/core/src/components/header/mobile-sidebar';
import { useTranslations } from '@eliadmin/core/src/hooks/use-translations';

export function HeaderClient({
  generalLayout,
  menu,
}: {
  generalLayout: GeneralLayout['data'];
  menu: Menu;
}) {
  const { t } = useTranslations();
  const [isScrolled, setIsScrolled] = useState(false);

  useEffect(() => {
    const handleScroll = () => setIsScrolled(window.scrollY > 0);

    handleScroll();
    window.addEventListener('scroll', handleScroll, { passive: true });
    return () => window.removeEventListener('scroll', handleScroll);
  }, []);

  return (
    <header
      className={cn(
        'fixed left-0 top-0 z-[40] w-full py-2 transition-all ease-in-out sm:py-4 lg:py-6',
        'custom-section',
        'ea-header',
        isScrolled && 'ea-header-client__scrolled bg-white',
      )}
    >
      <div
        className={cn('custom-container--xxl', 'hidden items-center justify-between gap-4 lg:flex')}
      >
        <Navigation menu={menu} type="header" className="flex-1" isReallyScrolled={isScrolled} />
        <Logo generalLayout={generalLayout} className={{ image: 'h-20' }} />
        <div className="flex w-full flex-1 items-center justify-end">
          <Button asChild>
            <Link prefetch={false} href={'/kontakt#kontakt'}>
              <ButtonIcon alt="Mám záujem o projekt" url="/images/icons/bubble-chat.svg" />
              Mám záujem o projekt
            </Link>
          </Button>
        </div>
      </div>
      <div className="flex w-full items-center justify-between lg:hidden">
        <div className="flex items-center justify-start gap-4">
          <MobileSidebar menu={menu.fields} side="left" isScrolled={isScrolled} />
          <Logo
            src={generalLayout?.header?.logo?.url}
            generalLayout={generalLayout}
            className={{ image: 'h-12' }}
          />
        </div>
        <Button asChild>
          <Link prefetch={false} href={'/kontakt#kontakt'}>
            <ButtonIcon alt={t('text1243')} url="/images/icons/bubble-chat.svg" />
            {t('text1243')}
          </Link>
        </Button>
      </div>
    </header>
  );
}
